<p-dialog [(visible)]="display" appendTo="body" [modal]="true"
[style]="{width: '60vw'}" styleClass="no-padding" (onHide)="close()" [showHeader]="false">
    <div *ngIf="!isView">
        <div class="p-field p-grid p-m-0">
            <div class="p-col-4 left p-px-0">
                <h5 class="p-p-3 p-mb-0">Add Phone Number</h5>
                <ul style="list-style: none;" class="p-m-0 p-p-0">
                    <li class="p-p-2 p-mb-2 p-d-flex current cursor-pointer" *ngIf="current1">
                        <div class="p-d-flex" style="width:2rem">
                            <span class="number">
                                1
                            </span>
                        </div>
                        <div class="p-mt-1">
                            <h6 class="p-mb-0">WA Business Profile</h6>
                        </div>
                    </li>
                    <li class="p-p-2 p-mb-2 p-d-flex" *ngIf="past1">
                        <div class="p-d-flex" style="width:2rem">
                            <span class="icon">
                                <i class="pi pi-check"></i>
                            </span>
                        </div>
                        <div class="p-mt-1">
                            <div class="p-mb-0" style="font-size: 1rem;">WA Business Profile</div>
                        </div>
                    </li>
            
                    <li class="p-p-2 p-mb-2 p-d-flex" *ngIf="current1">
                        <div class="p-d-flex" style="width:2rem">
                            <span class="number">
                                2
                            </span>
                        </div>
                        <div class="p-mt-1">
                            <div class="p-mb-0" style="font-size: 1rem;">Add Number</div>
                        </div>
                    </li>
                    <li class="p-p-2 p-mb-2 p-d-flex current cursor-pointer" *ngIf="current2">
                        <div class="p-d-flex" style="width:2rem">
                            <span *ngIf="!isRepeatNo" class="number">
                                2
                            </span>
                            <span *ngIf="isRepeatNo" class="icon red">
                                <i class="pi pi-exclamation-circle"></i>
                            </span>
                        </div>
                        <div class="p-mt-1">
                            <h6 class="p-mb-0">Add Number</h6>
                        </div>
                    </li>
                    <li class="p-p-2 p-mb-2 p-d-flex" *ngIf="past2">
                        <div class="p-d-flex" style="width:2rem">
                            <span class="icon">
                                <i class="pi pi-check"></i>
                            </span>
                        </div>
                        <div class="p-mt-1">
                            <div class="p-mb-0" style="font-size: 1rem;">Add Number</div>
                        </div>
                    </li>
            
                    <li class="p-p-2 p-d-flex" *ngIf="current1 || current2">
                        <div class="p-d-flex" style="width:2rem">
                            <span class="number">
                                3
                            </span>
                        </div>
                        <div class="p-mt-1">
                            <div class="p-mb-0" style="font-size: 1rem;">Verify Number</div>
                        </div>
                    </li>
                    <li class="p-p-2 p-d-flex current cursor-pointer" *ngIf="current3">
                        <div class="p-d-flex" style="width:2rem">
                            <span class="number">
                                3
                            </span>
                        </div>
                        <div class="p-mt-1">
                            <h6 class="p-mb-0">Verify Number</h6>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="p-col-8 card">
                <div class="p-p-2" *ngIf="current1">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-mt-2">
                            <h5 class="p-mb-2">Create a Whatsapp Business profile</h5>
                            <p class="p-mb-3">This profile will show information about your business to people on WhatsApp. You can edit this information anytime by goting to <b>Business Assets</b> in Meta Business Suite <b>Setting</b> and seleting this WhatsApp account.</p>
                        </div>
                        <button pButton pRipple icon="pi pi-times"
                        (click)="close()" class="p-button-text p-button-rounded p-pt-0"></button>
                    </div>
                    <div class="p-grid p-field">
                        <div class="p-col-12">
                            <h6 class="p-mb-2">WhatsApp Business Profile Display Name</h6>
                            <input id="name" type="text" pInputText [(ngModel)]="tempProduct.name">
                        </div>
                    </div>
                    <div class="p-grid p-field">
                        <div class="p-col-12">
                            <h6 class="p-mb-2">Timezone</h6>
                            <p-dropdown [options]="timezone" optionLabel="name" appendTo="body"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-grid p-field">
                        <div class="p-col-12">
                            <h6 class="p-mb-2">Category</h6>
                            <p-dropdown [options]="categories" optionLabel="name" appendTo="body"></p-dropdown>
                        </div>
                    </div>
                    <div class="p-grid p-field">
                        <div class="p-col-12">
                            <h6 class="p-mb-2">Business Description</h6>
                            <textarea class="w-100" rows="5" cols="30" pInputTextarea></textarea>
                        </div>
                    </div>
                </div>
                <div class="p-p-2" *ngIf="current2">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-mt-2">
                            <h5 class="p-mb-1">Add a phone number for WhatsApp</h5>
                            <p class="p-mb-3">This is the number people will see when they chat with you. <span class="text-blue-500">Learn how to use a number that's already on WhatsApp.</span></p>
                        </div>
                        <button pButton pRipple icon="pi pi-times"
                        (click)="close()" class="p-button-text p-button-rounded p-pt-0"></button>
                    </div>
                    <div class="p-d-flex">
                        <div class="p-mb-3 w-100">
                            <h6 class="p-mb-2">Phone Number</h6>
                            <div class="p-d-flex">
                                <p-dropdown [options]="prefix" [(ngModel)]="selectedPrefix" optionLabel="name" class="padding-1" appendTo="body"></p-dropdown>
                                <div class="inputgroup w-100" style="position: relative;">
                                    <p-inputMask mask="(999) 999-9999" [(ngModel)]="phoneNo" placeholder="(999) 999-9999" 
                                    [ngClass]="{'ng-invalid ng-dirty': isRepeatNo}"
                                    *ngIf="selectedPrefix.code == 'US';else otherMask;"></p-inputMask>
                                    <ng-template #otherMask>
                                        <input (keypress)="numberOnly($event)" [(ngModel)]="phoneNo" type="text" pInputText 
                                        [ngClass]="{'ng-invalid ng-dirty': isRepeatNo}">
                                    </ng-template>
                                    <span class="inputgroup-addon text-pink-500" *ngIf="isRepeatNo">
                                        <i class="pi pi-exclamation-triangle"></i>
                                    </span>
                                </div>
                            </div>
                            <div class="p-p-1">You'll receive a code to verify this number.</div>
                        </div>
                    </div>
                    <div class="p-mb-3" *ngIf="isRepeatNo">
                        <div class="p-d-flex p-p-3" style="background-color: #fad6d6;border:1px solid red">
                            <i class="pi pi-exclamation-triangle p-mr-3" style="color: red;"></i>
                            <p>
                                This number is registered to an existing WhatsApp account. To use this number, disconnect it from the exsiting account. Then, return to this page and re-enter the number. Note: It may take up to 3 minutes for the number to become available. <a class="text-blue-500 cursor-pointer">Learn more</a>
                            </p>
                        </div>
                    </div>
                    <div class="p-mb-3">
                        <h6 class="p-mb-2">Choose how you would like to verify this number:</h6>
                        <div>If you are using a landline number, choose phone call.</div>
                        <div class="p-mt-3 p-d-flex">
                            <div class="d-flex p-mr-3">
                                <p-radioButton name="verifyType" value="msg" [(ngModel)]="verifyType" inputId="verify1"></p-radioButton>
                                <label for="verify1" class="p-ml-2">Text message</label>
                            </div>
                            <div class="d-flex">
                                <p-radioButton name="verifyType" value="call" [(ngModel)]="verifyType" inputId="verify2"></p-radioButton>
                                <label for="verify2" class="p-ml-2">Phone call</label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="p-p-2" *ngIf="current3">
                    <div class="p-d-flex p-jc-between">
                        <div class="p-mt-2 text-900">
                            <h5 class="p-mb-1">Verify your phone number</h5>
                            <p class="p-mb-3">We sent a verification code to {{phoneNo}}. To verify your number, enter the 6 digit code. If this phone number is incorrect, <a class="text-blue-500 cursor-pointer" (click)="back2()">enter a different number.</a></p>
                        </div>
                        <button pButton pRipple icon="pi pi-times"
                        (click)="close()" class="p-button-text p-button-rounded p-pt-0"></button>
                    </div>
                    <div class="p-d-flex p-mt-3">
                        <div class="p-mb-3">
                            <h5 class="p-mb-1">Verification Code</h5>
                            <code-input [isCodeHidden]="true"
                                        [codeLength]="6"
                                        (codeChanged)="onCodeChanged($event)"
                                        (codeCompleted)="onCodeCompleted($event)">
                            </code-input>
                            <div class="p-p-1">Did not receive a code? You can request a new code and change your verification method in <b>{{counter}}</b> seconds.</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
    <ng-template pTemplate="footer">
        <ng-container *ngIf="!isView">
            <div class="flex gap-3 justify-content-end border-top-1 surface-border pt-2 pb-2" *ngIf="current1">
                <button pButton pRipple label="Cancel" (click)="close()" class="p-button-text"></button>
                <button pButton pRipple label="Next" (click)="next1()" class="p-button-rounded"></button>
            </div>
            <div class="flex gap-3 justify-content-end border-top-1 surface-border pt-2 pb-2" *ngIf="current2">
                <button pButton pRipple label="Back" (click)="back1()" class="p-button-text"></button>
                <button pButton pRipple label="Next" (click)="verifyNo()" class="p-button-rounded"></button>
            </div>
            <div class="flex gap-3 justify-content-end border-top-1 surface-border pt-2 pb-2" *ngIf="current3">
                <button pButton pRipple label="Back" (click)="back2()" class="p-button-text"></button>
                <button pButton pRipple label="Next" (click)="next3()" class="p-button-rounded"></button>
            </div>
        </ng-container>
        <ng-container *ngIf="isView">
            <div class="flex gap-3 justify-content-end border-top-1 surface-border pt-2 pb-2">
                <button pButton pRipple label="Cancel" (click)="close()"></button>
            </div>
        </ng-container>
    </ng-template>
</p-dialog>
